module.exports = __webpack_public_path__ + "img/workplay-15.30a09670.jpg";